export default {
  title: 'light',
  colors: {
    primary: '#f0f0f5',
    secundary: '#3c3744',
    background: '#f0f0f5',
    text: '#3a3a3a',

  },
};
